import React from "react"
import { AppToolbarCreateButton } from "@components"

import { useUserSettingsWebSupplierGroup } from "../@hooks"


export default function WebSupplierGroupTabButton() {
	const { handleSetFormData } = useUserSettingsWebSupplierGroup()

	return <AppToolbarCreateButton
		label="Define Group"
		onClick={handleSetFormData}
	/>
}